import { apiClient } from "./apiClient";

export interface ResetResponse {
  message: string;
}

// Step 1: ask Cognito to email a verification code to the user.
// Backend always returns "Success" regardless of whether the email exists,
// to avoid leaking which addresses are registered.
export async function requestPasswordReset(email: string): Promise<ResetResponse> {
  try {
    const response = await apiClient.post("/api/forgotPassword", { email });
    if (!response) return { message: "Network error" };
    return await response.json();
  } catch (error: any) {
    return { message: error?.message || "Failed to request password reset" };
  }
}

// Step 2: submit the code + new password to complete the reset.
// Backend surfaces specific errors here (wrong code, expired code,
// password policy, etc.) so the UI can show actionable messages.
export async function confirmPasswordReset(
  email: string,
  code: string,
  newPassword: string,
): Promise<ResetResponse> {
  try {
    const response = await apiClient.post("/api/confirmForgotPassword", {
      email,
      code,
      newPassword,
    });
    if (!response) return { message: "Network error" };
    return await response.json();
  } catch (error: any) {
    return { message: error?.message || "Failed to reset password" };
  }
}
